import { useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { useApiMutation } from '../useApiMutation';
import { apiPost, operationsClient } from '@/lib/api';
import { consentEndpoints } from '@/lib/api/endpoints';
import { consentKeys } from '@/lib/queryKeys';
import type { ConsentRecord } from '@/types/paymentSchedule';

export function useRevokeConsent(contactId?: string) {
  const queryClient = useQueryClient();
  return useApiMutation<ConsentRecord, { id: string }>({
    mutationFn: ({ id }) =>
      apiPost<ConsentRecord, undefined>(operationsClient, consentEndpoints.revoke(id), undefined),
    onSuccess: (record) => {
      const cId = contactId ?? record.contactId;
      void queryClient.invalidateQueries({
        queryKey: consentKeys.byContact(cId, false),
      });
      void queryClient.invalidateQueries({
        queryKey: consentKeys.byContact(cId, true),
      });
      toast.success('Consent revoked');
    },
  });
}
